import { Badge } from '../../../components/ui/badge';
import { CheckCircle2, XCircle, AlertTriangle, Clock } from 'lucide-react';
import type { ImportSummary } from '../../../lib/api/barratt';

type ImportStatusBadgeProps = Pick<ImportSummary, 'is_complete' | 'is_success' | 'has_errors' | 'total_added'>;

/** Processing, Complete, Completed with Errors, or Failed for one import. */
export default function ImportStatusBadge({ is_complete, is_success, has_errors, total_added }: ImportStatusBadgeProps) {
  if (!is_complete) {
    return (
      <Badge variant="outline" className="bg-yellow-50 text-yellow-700 border-yellow-200">
        <Clock className="h-3 w-3 mr-1" />
        Processing
      </Badge>
    );
  }

  // Completed with Errors: some rows imported, some failed
  if (has_errors && total_added && total_added > 0) {
    return (
      <Badge variant="outline" className="bg-orange-50 text-orange-700 border-orange-200">
        <AlertTriangle className="h-3 w-3 mr-1" />
        Completed with Errors
      </Badge>
    );
  }

  if (is_success) {
    return (
      <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
        <CheckCircle2 className="h-3 w-3 mr-1" />
        Complete
      </Badge>
    );
  }

  // All rows failed
  return (
    <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">
      <XCircle className="h-3 w-3 mr-1" />
      Failed
    </Badge>
  );
}
